module.exports = __webpack_public_path__ + "img/pic_xishouye1.0fed2575.png";